import React from 'react';
import clsx from 'clsx';
import { Container } from 'semantic-ui-react';
import Selectors from '@/layout/hooks/selectors';
import RibbonLaunchers from '../ribbon-launchers/RibbonLaunchers';
import RibbonActions from './RibbonActions';
import RibbonLayout from './RibbonLayout';

const Ribbon = () => {
  const state = Selectors.useRibbon();
  return (
    <Container
      className={clsx(
        'ribbon aridhia-ribbon',
        `aridhia-theme-${state.theme}`,
        !state.visible && 'no-ribbon',
        !state.hasLabels && 'no-label',
        state.fullscreen ? 'full-screen' : 'no-full-screen',
      )}
    >
      <RibbonLaunchers />
      <RibbonActions />
      <RibbonLayout />
    </Container>
  );
};

export default Ribbon;
